import { createClient } from '@wallyhealth/web-core'
import config from '../../config'

const client = createClient({ baseUrl: config.PATIENT_KAPI_URL })

const marketingClient = createClient({
  baseUrl: config.MARKETING_KAPI_URL,
  timeout: 30000
})

export const fetchJoinFlowConfig = ({ selector }) =>
  marketingClient.get(`/join-flow-config/selector/${selector}`)
    .then(response => response.data)

export const prepSubscription = ({ billing, patient, addresses = {}, locationId, geoId }) => {
  const body = { billing, patient, addresses, locationId, geoId }

  return client.post('/billing/subscriptions/prepped', body)
    .then(response => response.data)
}

export const fetchPricing = ({ couponCode }) => {
  const params = couponCode
    ? { coupon: couponCode }
    : {}

  return client.get('/billing/pricing', { params })
    .then(response => response.data)
}
